import { ProfessionsServiceInterface } from 'domain/services';
import { GetAllProfessionsUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getAllProfessions: GetAllProfessionsUseCaseInterface;
}

export class ProfessionsService implements ProfessionsServiceInterface {
  private readonly _getAllProfessions: GetAllProfessionsUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllProfessions = usecases.getAllProfessions;
  }

  getAllProfessions(
    params?: GetAllProfessionsUseCaseInterface.Params,
  ): Promise<GetAllProfessionsUseCaseInterface.Result> {
    return this._getAllProfessions.execute(params);
  }
}
